import { createAsyncThunk } from '@reduxjs/toolkit';
import folderApi from '~/apis/folder';
import {
  CREATE_FOLDER,
  GET_FILE_FROM_FOLDER,
  GET_FOLDER,
  GET_FOLDERS,
  UPDATE_FOLDER,
} from '~/utils/constants/actionType';
import {
  IEditFolder,
  IParamGetFileFromFolder,
  IResponseGetFolderDetail,
  IResponseGetFolders,
} from '~/utils/interface/folder';
import { IResponseGetFiles } from '~/utils/interface/job';

export const handleGetFolders = createAsyncThunk<IResponseGetFolders>(
  GET_FOLDERS,
  async (_params, { rejectWithValue }) => {
    try {
      const res = await folderApi.getFolders();

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateFolder = createAsyncThunk<IResponseGetFolderDetail, IEditFolder>(
  CREATE_FOLDER,
  async (data: IEditFolder, { rejectWithValue }) => {
    try {
      const res = await folderApi.createFolder(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetFolder = createAsyncThunk<IResponseGetFolderDetail, string>(
  GET_FOLDER,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await folderApi.getFolder(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateFolder = createAsyncThunk<null, { id: number | string; params: IEditFolder }>(
  UPDATE_FOLDER,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await folderApi.updateFolder(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetFilesFromFolder = createAsyncThunk<
  IResponseGetFiles,
  { id: string | undefined; params: IParamGetFileFromFolder }
>(GET_FILE_FROM_FOLDER, async ({ id, params }, { rejectWithValue }) => {
  try {
    const res = await folderApi.getFilesFromFolder(id, params);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
